import { render, staticRenderFns } from "./EmbeddedLocation.vue?vue&type=template&id=f201082e&scoped=true&"
import script from "./EmbeddedLocation.vue?vue&type=script&lang=js&"
export * from "./EmbeddedLocation.vue?vue&type=script&lang=js&"
import style0 from "./EmbeddedLocation.vue?vue&type=style&index=0&id=f201082e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f201082e",
  null
  
)

export default component.exports